export default __webpack_public_path__ + "static/media/kashi-kanji-wires.4c708567.png";